export const storageTypes = {
  UPLOAD_FILE_START: "UPLOAD_FILE_START",
  UPLOAD_FILE_SUCCESS: "UPLOAD_FILE_SUCCESS",
  UPLOAD_FILE_FAILED: "UPLOAD_FILE_FAILED",
  UPLOAD_FILE_END: "UPLOAD_FILE_END",

  DOWNLOAD_FILE_START: "DOWNLOAD_FILE_START",
  DOWNLOAD_FILE_SUCCESS: "DOWNLOAD_FILE_SUCCESS",
  DOWNLOAD_FILE_FAILED: "DOWNLOAD_FILE_FAILED",
  DOWNLOAD_FILE_END: "DOWNLOAD_FILE_END",
};
